import React from 'react';

import { DataDisputeReportInfoFragment } from 'src/api';
import { HiddenResultsTable } from 'src/components/common';
import { TableColumn } from 'src/components/table';
import { useFilterStorage, useSearch } from 'src/hooks/common';
import { useDataDisputeReportList } from 'src/hooks/reports';
import { useDataDisputeReportTableRowActions } from 'src/hooks/reports/';
import { useCurrentUser } from 'src/hooks/user';
import { getEmployeeFilterManager } from 'src/utils/filters';

import { getDataDisputeReportTableColumnsEmployerStaff } from '../utils';

export const DataDisputeReportTableEmployerManager: React.FC = () => {
  const { searchValue } = useSearch();
  const { timezone } = useCurrentUser();
  const { pagination } = useFilterStorage();
  const rowActions = useDataDisputeReportTableRowActions();

  const { dataDisputeReportList, dataDisputeReportListCount, loading } = useDataDisputeReportList({
    skip: !searchValue,
    prepareSearchFilterCb: searchValue => ({
      employee: getEmployeeFilterManager(searchValue),
    }),
  });

  const columns = React.useMemo<Array<TableColumn<DataDisputeReportInfoFragment>>>(
    () => getDataDisputeReportTableColumnsEmployerStaff(timezone),
    [timezone],
  );

  return (
    <HiddenResultsTable<DataDisputeReportInfoFragment>
      columns={columns}
      rowActions={rowActions}
      items={dataDisputeReportList}
      itemsCount={dataDisputeReportListCount}
      pagination={pagination}
      loading={loading}
    />
  );
};
